import FieldReadOnly from "../../../generic/read-only-value/read-only"
import FieldConfig from "../../../proto/field-config"
import FieldTimeReportId_ViewProperty from "./view-property"

export default class FieldTimeReportId extends FieldReadOnly {

    constructor(config: FieldConfig) {
        super(config)

        this.icon = 'i5-id'

        this.renderComponents.viewProperty = FieldTimeReportId_ViewProperty

        this.isSortByAvailable = false
    }
}
